import { render, staticRenderFns } from "./PopupBlockerBanner.vue?vue&type=template&id=35b37ed2"
import script from "./PopupBlockerBanner.vue?vue&type=script&lang=ts"
export * from "./PopupBlockerBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports